(function () {
  function buildPolicyPage() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || container.dataset.civettaReady === 'true') return;
    container.dataset.civettaReady = 'true';

    var titleArea = container.querySelector('.shopify-policy__title');
    var title = titleArea && titleArea.querySelector('h1');
    var source = container.querySelector('.shopify-policy__body .rte > div');
    if (!titleArea || !title || !source) return;

    title.textContent = 'Returns & Exchanges';

    var eyebrow = document.createElement('span');
    eyebrow.className = 'civetta-policy-eyebrow';
    eyebrow.textContent = 'Civetta Care';
    titleArea.insertBefore(eyebrow, title);

    var subtitle = document.createElement('p');
    subtitle.className = 'civetta-policy-subtitle';
    subtitle.textContent = 'A clear, comfortable process if your order is not quite right.';
    titleArea.appendChild(subtitle);

    var summary = document.createElement('nav');
    summary.className = 'civetta-policy-summary';
    summary.setAttribute('aria-label', 'Policy at a glance');
    summary.innerHTML =
      '<a href="#policy-request-window"><strong>3 calendar days</strong><span>Submit your request after delivery</span></a>' +
      '<a href="#policy-how-to-submit-a-request"><strong>WhatsApp or Instagram</strong><span>Send your order details and clear photos</span></a>' +
      '<a href="#policy-returns-after-accepting-delivery"><strong>200 EGP pickup</strong><span>Only for eligible returns after accepting delivery</span></a>';
    titleArea.insertAdjacentElement('afterend', summary);

    var duplicateTitle = source.querySelector(':scope > h2:first-child');
    if (duplicateTitle) duplicateTitle.hidden = true;

    var children = Array.prototype.slice.call(source.children);
    var currentSection = null;

    children.forEach(function (child) {
      if (child === duplicateTitle) return;

      if (child.tagName === 'H3') {
        currentSection = document.createElement('section');
        currentSection.className = 'civetta-policy-section';
        source.insertBefore(currentSection, child);

        var slug = child.textContent
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
        child.id = 'policy-' + slug;

        if (
          slug === 'request-window' ||
          slug === 'how-to-submit-a-request' ||
          slug === 'returns-after-accepting-delivery'
        ) {
          currentSection.classList.add('is-key');
        }

        currentSection.appendChild(child);
      } else if (currentSection) {
        currentSection.appendChild(child);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildPolicyPage);
  } else {
    buildPolicyPage();
  }
})();

